/**
 * Distillation lab control buttons.
 *
 * SPDX-License-Identifier: LicenseRef-Proprietary
 * Copyright (c) 2026 Invariant Holdings LLC
 */
import React from "react";
import {
  MonographControlButton,
  PanelSurface,
  panelTokens,
} from "@csk/demo-ui";
export interface DistillationLabControlsProps {
  readonly fixedPoint: boolean;
  readonly onStep: () => void;
  readonly onRun: () => void;
  readonly onReset: () => void;
}
export function DistillationLabControls({
  fixedPoint,
  onStep,
  onRun,
  onReset,
}: DistillationLabControlsProps): React.JSX.Element {
  return (
    <>
      <PanelSurface.SectionHeading>Controls</PanelSurface.SectionHeading>
      <PanelSurface.Card>
        <div className="flex flex-wrap gap-2">
          <MonographControlButton
            tokens={panelTokens}
            onClick={onStep}
            disabled={fixedPoint}
            color={panelTokens.distill}
          >
            Distill step
          </MonographControlButton>
          <MonographControlButton
            tokens={panelTokens}
            onClick={onRun}
            disabled={fixedPoint}
            color={panelTokens.immune}
          >
            Run to fixed point
          </MonographControlButton>
          <MonographControlButton
            tokens={panelTokens}
            onClick={onReset}
            color={panelTokens.muted}
          >
            Reset to ALLOW₀
          </MonographControlButton>
        </div>
      </PanelSurface.Card>
    </>
  );
}
